import * as React from "react";
import { browserHistory } from "react-router"

import { appContext } from "../App/appContext"

import Models = Gf.Web.Models;

function addContextPathAndFixUrl(path: string, fixUrl: boolean = true): string {
  return appContext.addContextPathAndFixUrl((path.indexOf("/") === 0 ? path : `/${path}`), fixUrl);
}

/**
 * Programmatically navigate to the same url used in <RouteLink to="..." /> tags
 * @param path   Url WITHOUT context path first, e.g. "/product" and not "/profile/product"
 */
export function navigateToRoute(path: string, fixUrl: boolean = true): void {
    browserHistory.push(addContextPathAndFixUrl(path, fixUrl));
}

export function replaceRoute(path: string, fixUrl: boolean = true): void {
    browserHistory.replace(addContextPathAndFixUrl(path, fixUrl));
}

export function naviagateToAbsoluteUrl(url: string): void {
    window.location.href = url;
}

export function navigateToLocalPath(path: string, fixUrl: boolean = true): void {
    naviagateToAbsoluteUrl(addContextPathAndFixUrl(path, fixUrl));
}

/******************** ClickButton - a button which can be clicked but which does not do anything else **********************/

export function getStyle(flagg: Models.HandlingFlagg): string | undefined {
    switch(flagg) {
    case Models.HandlingFlagg.Primær:
        return "primary";
    case Models.HandlingFlagg.Suksess:
        return "success";
    case Models.HandlingFlagg.Info:
        return "info";
    case Models.HandlingFlagg.Advarsel:
        return "warning";
    case Models.HandlingFlagg.Fare:
        return "danger";
    case Models.HandlingFlagg.Link:
        return "link";
    }
    return undefined;
}



// WEBPACK FOOTER //
// ./Scripts/React/Component/navigation.tsx